<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {appEvents} from '../../services';
  import {draftStore, faceTrackingStore, preview, project} from '../../store';
  import {writable} from 'svelte/store';

  let fakeTimedUpdate = writable(0);

  $: progress = $faceTrackingStore.trackingProgress || 0;
  $: compileProgress = $faceTrackingStore.compileProgress || 0;

  const trackingMultiplier = $faceTrackingStore.v2 ? 0.5 : 1; // We dont emit compile progress events on version 1 of the ai tracker.
  $: totalProgress =
    $faceTrackingStore.trackingProgress || $faceTrackingStore.compileProgress
      ? (progress * trackingMultiplier + compileProgress * 0.4 + $fakeTimedUpdate).toFixed(0)
      : 0;

  function handleVideoTrackingProgress(data: any) {
    console.log('video-tracking-progress', data);
    faceTrackingStore.update(store => ({...store, trackingProgress: data.progress}));
    // if(data.video_url === $project.compiledVideo?.cloudLocation) {
    // }
  }

  function parseTimeString(str: string) {
    // time: '00:00:17.86',
    const time = str.split(':');
    const hours = parseInt(time[0]);
    const minutes = parseInt(time[1]);
    const seconds = parseFloat(time[2]);
    console.log('split time', time);
    return hours * 60 * 60 + minutes * 60 + seconds;
  }

  function handleSegmentedVideo(message: any) {
    console.log('segmented video', message);
    fakeTimedUpdate.set(0);
    const time = () =>
      setTimeout(() => {
        if ($fakeTimedUpdate < 10) {
          fakeTimedUpdate.update(store => store + 1);
          time();
        }
      }, 3000);

    time();
  }
  function handleCompileProgress({data}: any) {
    try {
      fakeTimedUpdate.set(10);
      const parsedTimestamp = parseTimeString(data.progress.time);
      console.log('parsedtimestamp', parsedTimestamp);
      const totalProgress = (parsedTimestamp / $preview.totalDuration) * 100;
      console.log('compile progress', totalProgress);
      faceTrackingStore.update(store => ({...store, compileProgress: totalProgress}));
    } catch (err) {
      console.warn('Error on handling compile progess', err);
    }
  }

  onMount(() => {
    appEvents.on('video-tracking-progress', handleVideoTrackingProgress);
    appEvents.on('video.track.v2.compile-progress', handleCompileProgress);
    appEvents.on('video.track.v2.segmented-video', handleSegmentedVideo);
  });

  onDestroy(() => {
    appEvents.off('video-tracking-progress', handleVideoTrackingProgress);
    appEvents.off('video.track.v2.compile-progress', handleCompileProgress);
    appEvents.off('video.track.v2.segmented-video', handleSegmentedVideo);
  });
</script>

<div class="w-full rounded-md border border-gray-200 bg-gray-100 px-2 py-3 text-xs">
  <div class="flex w-full font-semibold">
    <span class="inline-block">
      {totalProgress > 0 ? 'Reframing your shot...' : 'Booting up AI Camera Crew'}
      <i class="fa fa-spinner animate-spin"></i>
    </span>
    {#if totalProgress > 0}
      <span class="ml-auto inline-block">{totalProgress}%</span>
    {/if}
  </div>
  <div class="mt-3 block">
    <div class="h-1.5 w-full bg-neutral-200 dark:bg-neutral-600">
      {#if totalProgress > 0}
        <div class="h-1.5 bg-primary" style="width: {totalProgress}%"></div>
      {/if}
    </div>
  </div>
</div>
